import React from 'react';
import { LeftAndRightAlignment } from 'web-ui-components/lib/global/layout';
import { Title } from 'web-ui-components/lib/atoms/text';
import { Button } from 'web-ui-components/lib/atoms/buttons';
import { Field } from 'web-ui-components/lib/molecules/forms';
import InternetBankingActions from '../../../actions/InternetBankingActions';

const AccountPoolHeaderButtons = ({
  editPool,
  deletePool,
  content: {
    createAnotherPoolButton,
    editPoolButton,
    deletePoolButton,
    viewPoolScreenTitle,
  },
}) => {
  const leftNode = (
    <Title className="u-margin-bottom-0" size="h1">
      {viewPoolScreenTitle}
    </Title>
  );
  const rightNode = (
    <Field>
      <Button
        display="primary"
        onClick={() =>
          InternetBankingActions.navigateToWebTask('WEB-CREATE-POOL')
        }
      >
        {createAnotherPoolButton}
      </Button>
      <Button className="u-margin-left-3" display="primary" onClick={editPool}>
        {editPoolButton}
      </Button>
      <Button
        className="u-margin-left-3"
        display="primary"
        onClick={deletePool}
      >
        {deletePoolButton}
      </Button>
    </Field>
  );
  return (
    <Field className="web-ui-components">
      <LeftAndRightAlignment leftNode={leftNode} rightNode={rightNode} />
    </Field>
  );
};
export default AccountPoolHeaderButtons;
